import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Appconfig from "../../config/config";
import Helper from "../../helper";
import Footer from "../Footer/Footer";
import moment from "moment";

function ProfitLossEventMarkets() {
  const params = useParams();
  const userInfo = Helper(); // get login user details

  const [filteredData, setFilteredData] = useState([]);
  const [requestType, setRequestType] = useState("");
  const [formData, setFormData] = useState({
    user_id: userInfo && userInfo?._id,
    from_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
    to_date: moment().format("YYYY-MM-DD"),
    type: "All",
  });

  // ✅ handle filters
  const handleToDate = (newDate) => {
    if (newDate) setFormData({ ...formData, to_date: newDate });
  };
  const handleFromDate = (newDate) => {
    if (newDate) setFormData({ ...formData, from_date: newDate });
  };
  const handleChangeType = (value) => {
    if (value) setFormData({ ...formData, type: value });
  };

  // ✅ API call
  const filterProfitLossByEventMarkets = async () => {
    try {
      const { data } = await axios.post(
        `${Appconfig.apiUrl}reports/auraProfitLossByEventMarketsAll`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      setRequestType(formData?.type);
      setFilteredData(data.resultData || []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    filterProfitLossByEventMarkets();
    // eslint-disable-next-line
  }, []);

  // ✅ Deposit / Withdraw Rows
  const renderDWRows = () =>
    filteredData.map((record, index) => (
      <tr key={index} className="bg-white hover:bg-gray-50 transition">
        <td className="px-3 py-2 border text-sm text-gray-700 whitespace-nowrap">
          {new Date(record.createdAt).toLocaleString()}
        </td>
        <td className="px-3 py-2 border text-sm text-gray-700 whitespace-nowrap">
          {record.remarks}
        </td>
        <td className="px-3 py-2 border text-sm font-semibold text-green-600 text-center whitespace-nowrap">
          {record.transaction_type === "Credit" ? record.amount : "-"}
        </td>
        <td className="px-3 py-2 border text-sm font-semibold text-red-600 text-center whitespace-nowrap">
          {record.transaction_type === "Debit" ? record.amount : "-"}
        </td>
        <td className="px-3 py-2 border text-sm text-gray-700 whitespace-nowrap">
          <div className="flex items-center justify-center gap-1">
            {record.from}
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="black"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M9 17V7L16 12L9 17Z" />
            </svg>
            {record.to}
          </div>
        </td>
        <td className="px-3 py-2 border text-sm font-semibold text-gray-700 text-center whitespace-nowrap">
          {record.balance}
        </td>
      </tr>
    ));

  // ✅ Profit & Loss Rows
  const renderPLRows = () =>
    filteredData.map((record, index) => (
      <tr key={index} className="bg-white hover:bg-gray-50 transition">
        <td className="px-4 py-3 border text-sm text-gray-700 text-center whitespace-nowrap">
          {record.event_type === 4
            ? "Cricket"
            : record.event_type === 2
            ? "Tennis"
            : record.event_type === 1
            ? "Soccer"
            : record.event_type === 777
            ? "WCO Casino"
            : record.type || "Casino"}
        </td>
        <td className="px-3 py-2 border text-sm text-gray-700 whitespace-nowrap">
          {record.type
            ? record.remarks
            : record.event_type === 777
            ? record.remarks
            : record.event_name}
        </td>
        <td className="px-4 py-3 border text-sm text-gray-700 text-center whitespace-nowrap">
          {record.market_name === "Fancy" ? "-" : record.market_id}
        </td>
        <td className="px-3 py-2 border text-sm font-semibold text-blue-600 whitespace-nowrap">
          {record.event_type === 777 || record.type ? (
            "-"
          ) : (
            <Link
              to={`/profit-loss-bet-history/${record.match_id}/${record.market_name}/${record.market_id || record.selection_id}/${formData?.from_date}/${formData?.to_date}`}
              className="hover:underline"
            >
              {record.market_name + " / " + record.place_name}
            </Link>
          )}
        </td>
        <td className="px-4 py-3 border text-sm text-gray-700 text-center whitespace-nowrap">
          {record?.result_name || "-"}
        </td>
        <td className="px-3 py-2 border text-sm font-bold text-center whitespace-nowrap">
          {record.totalPL < 0 ? (
            <span className="text-red-600">{record?.totalPL?.toFixed(2)}</span>
          ) : (
            <span className="text-green-600">{record?.totalPL?.toFixed(2)}</span>
          )}
        </td>
        <td className="px-4 py-3 border text-sm text-gray-700 text-center whitespace-nowrap">
          {record?.totalBalance ? record?.totalBalance.toFixed(2) : "-"}
        </td>
        <td className="px-4 py-3 border text-sm text-gray-700 text-center whitespace-nowrap">
          {record.event_type === 777 || record.type
            ? new Date(record.createdAt).toLocaleString()
            : new Date(record.settledTime).toLocaleString()}
        </td>
      </tr>
    ));

  return (
    <>
      <div className="p-2">
        <h2 className="text-xl md:text-2xl font-bold text-emerald-700 mb-2">
          Profit & Loss By Event Markets
        </h2>

        {/* ✅ Filter Card */}
        <div className="bg-white shadow-md rounded-xl p-4 mb-3">
          <form className="space-y-4">
            {/* Type Select */}
            <div>
              <select
                value={formData?.type}
                onChange={(e) => handleChangeType(e.target.value)}
                className="w-full rounded-lg border px-3 py-2 text-sm font-medium focus:ring-2 focus:ring-emerald-500"
              >
                <option value="All">ALL</option>
                <option value="D&W">D & W</option>
                <option value="WCO">WCO</option>
                <option value="Sports">Sports</option>
              </select>
            </div>

            {/* Date Filters */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="date"
                value={formData?.from_date}
                onChange={(e) => handleFromDate(e.target.value)}
                className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-500"
              />
              <input
                type="date"
                value={formData?.to_date}
                onChange={(e) => handleToDate(e.target.value)}
                className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-500"
              />
            </div>

            {/* Buttons */}
            <div className="flex gap-3">
              <button
                type="button"
                onClick={filterProfitLossByEventMarkets}
                className="bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2 rounded-lg text-sm font-medium shadow-md transition"
              >
                Submit
              </button>
              <button
                type="reset"
                className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-5 py-2 rounded-lg text-sm font-medium shadow-md transition"
              >
                Reset
              </button>
            </div>
          </form>
        </div>

        {/* ✅ Responsive Table */}
        <div className="overflow-x-auto bg-white shadow-md rounded-xl text-sm font-medium bg-white hover:bg-[#f1faf7] transition">
          <table className="w-full border-collapse text-sm min-w-max">
            <thead>
              {requestType === "D&W" ? (
                <tr className="bg-emerald-600 text-white text-sm">
                  <th className="px-4 py-3 border whitespace-nowrap">Date</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Remark</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Deposit</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Withdraw</th>
                  <th className="px-4 py-3 border whitespace-nowrap">From / To</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Balance</th>
                </tr>
              ) : (
                <tr className="bg-emerald-600 text-white text-sm">
                  <th className="px-4 py-3 border whitespace-nowrap">Sport Name</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Event Name</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Market Id</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Market Name</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Result</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Profit / Loss</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Total Balance</th>
                  <th className="px-4 py-3 border whitespace-nowrap">Settle Time</th>
                </tr>
              )}
            </thead>
            <tbody>
              {requestType === "D&W" ? renderDWRows() : renderPLRows()}
            </tbody>
          </table>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
}

export default ProfitLossEventMarkets;
